import { useQuery } from '@tanstack/react-query';
import type { EventsControllerQueryEventsParams } from '@/generated/api/model';
import { eventsControllerQueryEvents } from '@/generated/api/events/events';

export function useEvents(params: EventsControllerQueryEventsParams = {}) {
  return useQuery({
    queryKey: ['events', params],
    queryFn: async () => {
      const response = await eventsControllerQueryEvents(params);
      return response.data;
    },
    staleTime: 30000, // 30 seconds
  });
}
